module.exports = __webpack_public_path__ + "static/media/power-off.5eec98fa.svg";